module.exports = __webpack_public_path__ + "img/icon79-bg.3c6eb9a5.png";